import * as angular from 'angular';
import { BrowserDetector } from 'modules/application/misc/BrowserDetector';
export class WindowService {
    static $inject = ['$window'];
    constructor($window) {
        'ngInject';
        this.$window = $window;
        this.element = angular.element(this.$window);
        const detector = new BrowserDetector();
        this.isMobile = detector.isMobile;
    }
}
WindowService.$inject = ['$window'];
